import script from "./MenuCompose.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuCompose.vue?vue&type=script&setup=true&lang=js"

import "./MenuCompose.vue?vue&type=style&index=0&id=38170ab5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38170ab5"]])

export default __exports__